/** 快钱订单查询成功后保留各笔交易的退款返回码与原始文案。 */
export function parseKqRefundStatus(response) {
  if (response?.code !== 200) {
    throw new Error(
      response?.content || response?.message || response?.msg || "快钱退款结果查询失败",
    );
  }
  const transactions = response.data?.txnList;
  if (
    !Array.isArray(transactions) ||
    transactions.some((txn) => !txn || typeof txn !== "object" || Array.isArray(txn))
  ) {
    throw new Error("快钱退款结果格式异常");
  }
  return transactions;
}
